<!--
* @description  参数1
* @fileName  statusDialog
* @author userName
* @date 2024-01-19 11:38:37
!-->
<template>
	<div id="statusDialog" class="statusDialog">
		<div class="status-main">
			<div class="status-main-title">SHIPMENT STATUS<i class="el-icon-arrow-up" /></div>
			<div class="status-main-c">
				<div v-for="(item,index) in list" :key="index" class="status-main-item">
					<img class="mr8" :src="imgOption[item.type].url" width="16px" height="16px">
					<span :class="imgOption[item.type].color">{{ item.title }}</span>
					<div v-if="index + 1 < list.length" class="stups">
						<div class="line" />
						<div class="status-describe">
							<span v-if="[0,3].includes(item.type)">{{ item.content }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'StatusDialog',
		components: {
			// 组件的引用
		},
		props: {
			// 父辈向子辈传参
		},
		data() {
			return {
				list: [
					// type  0:失败 1:未进行中 2:成功 3:进行中
					{
						title: 'Booking Placed',
						type: 0,
						content: 'Before we can process your shipment, you must fill in the required shipping instructions below. We will be in touch within 24 hours if anything needs to be adjusted.'
					},
					{
						title: 'Booking Sent to DTMS',
						type: 1,
						content: 'Your instructions has been passed on to DTNS and we will arrange for pickup.'
					},
					{
						title: 'Goods Received',
						type: 1,
						content: 'Your goods has been received on Oct 22, 2023.'
					},
					{
						title: 'Space Booked',
						type: 1,
						content: 'We has updated the space information in the section below.'
					},
					{
						title: 'Shipped',
						type: 1,
						content: 'Your shipment has left the port and is making its way to the destination port.'
					},
					{
						title: 'Delivered',
						type: 1,
						content: ''
					}
				],
				imgOption: {
					0: {
						url: require('../../../../assets/img/manage/ic_warning@2x.png'),
						color: 'fcolor-red'
					},
					1: {
						url: require('../../../../assets/img/client/booking/icon-not.png'),
						color: 'fcolor-gray'
					},
					2: {
						url: require('../../../../assets/img/client/booking/icon-success.png'),
						color: 'fcolor-blue'
					},
					3: {
						url: require('../../../../assets/img/client/booking/icon-active.png'),
						color: 'fcolor-gree'
					}
				},
				data: {}
			}
		},
		computed: {
			// 计算属性
		},
		watch: {
			// 监测变化
		},
		created() {
			// 实例被创建之后执行代码
		},
		mounted() {
			// 页面进入时加载内容
		},
		methods: {
			init(data) {
				this.data = data
				this.list.forEach(item => {
					item.type = 1
				})
				switch (data.status) {
					case 1:
						this.list[0].type = 0
						break
					case 2:
						this.list[0].type = 2
						this.list[1].type = 3
						break
					case 3:
						this.list[0].type = 2
						this.list[1].type = 2
						this.list[2].type = 3
						break
					case 4:
						this.list[0].type = 2
						this.list[1].type = 2
						this.list[2].type = 2
						this.list[3].type = 3
						break
					case 5:
						this.list[0].type = 2
						this.list[1].type = 2
						this.list[2].type = 2
						this.list[3].type = 2
						this.list[4].type = 3
						break
					case 6:
						this.list.forEach(item => {
							item.type = 2
						})
						this.list[5].type = 3
						break
				}
			}
		}
	}
</script>
<style scoped lang='scss'>
	.statusDialog {
		z-index: 101;
		position: relative;
		top: -113px;
	}

	.mr8 {
		margin-right: 8px;
	}

	.fcolor-red {
		color: #EF0A0A;
	}

	.fcolor-gray {
		color: #C5D9ED;
	}

	.fcolor-gree {
		color: #1DB62F;
	}

	.fcolor-blue {
		color: #8EC0F2;
	}

	.status-main {
		width: 416px;
		background: #FFFFFF;
		box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);
		border-radius: 8px;
		border: 1px solid rgba(221, 221, 221, 0.56);

		.status-main-title {
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 550;
			color: #333333;
			margin: 8px 16px 0px;
		}

		.status-main-c {
			padding: 10px 16px 24px 16px;

			.status-main-item {
				margin-top: 12px;

				img {
					position: relative;
				}

				.stups {
					display: flex;

					.status-describe {
						padding: 16px;
					}

					.line {
						width: 1px;
						background: #DEEAF5;
						min-height: 24px;
						margin: -10px 0 -10px 8px;
					}
				}
			}
		}
	}
</style>